'use client'

import { useState } from 'react'
import { LoadingSpinner } from '@/frontend/design-system/atoms/LoadingSpinner'
import { Preview } from '@/frontend/design-system/forms/MarkdownEditor'

type PreviewWrapperProps = {
  className?: string
  content: { markdown: string }
}

export function PreviewWrapper({ content, className }: PreviewWrapperProps) {
  const [isPreviewReady, setIsPreviewReady] = useState(false)

  return (
    <div className={className ? `relative ${className}` : 'relative'}>
      {!isPreviewReady && (
        <div className='absolute inset-0 flex items-center justify-center'>
          <LoadingSpinner />
        </div>
      )}
      <Preview content={content} className={className} onReady={() => setIsPreviewReady(true)} />
    </div>
  )
}
